import { Action } from '@ngrx/store';
import { HistoryTerm, Category, Suggestion } from '~app/modules/generic/models';
import { SearchFromHeaderBarPayload } from '~app/modules/generic/models/search-from-header-bar-payload.model';

export enum SearchActionTypes {
  FOCUS_ON_SEARCH = '[Buyer] Search focus',

  START_SEARCH = '[Buyer] Start search',
  SEARCH_FROM_HEADER_BAR = '[Buyer] Search from header bar',
  CATEGORY_SELECT = '[Buyer] Category select',

  UPDATE_SEARCH_QUERY = '[Buyer] Update search query',

  NAVIGATE_SEARCH_ROUTE = '[Buyer] Navigate to search route',
  RESET_NAVIGATE_SEARCH_ROUTE = '[Buyer] Reset navigate to search route',
}

export class FocusOnSearch implements Action {
  readonly type = SearchActionTypes.FOCUS_ON_SEARCH;

  constructor(public payload: boolean) {}
}

export class UpdateSearchQuery implements Action {
  readonly type = SearchActionTypes.UPDATE_SEARCH_QUERY;

  constructor(public payload: string) {}
}

export class StartSearch implements Action {
  readonly type = SearchActionTypes.START_SEARCH;

  constructor(public payload: Suggestion | HistoryTerm) {}
}

export class SearchFromHeaderBar implements Action {
  readonly type = SearchActionTypes.SEARCH_FROM_HEADER_BAR;

  constructor(public payload: SearchFromHeaderBarPayload) {}
}

export class CategorySelect implements Action {
  readonly type = SearchActionTypes.CATEGORY_SELECT;

  constructor(public payload: Category) {}
}

export class NavigateToSearchRoute implements Action {
  readonly type = SearchActionTypes.NAVIGATE_SEARCH_ROUTE;
}

export class ResetNavigateToSearchRoute implements Action {
  readonly type = SearchActionTypes.RESET_NAVIGATE_SEARCH_ROUTE;
}

export type SearchActionsUnion =
  | FocusOnSearch
  | UpdateSearchQuery
  | StartSearch
  | CategorySelect
  | SearchFromHeaderBar
  | NavigateToSearchRoute
  | ResetNavigateToSearchRoute;
